import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { List, ListItem } from '@material-ui/core';
import { AppTheme } from '../../styles/AppTheme';


export class ButtonList extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }


  render() {
    const items = this.props && this.props.items || []

    if(!items && items.length === 0) {
      return null
    }

    return(
      <List>
        {items.map((item, index) => (
          <ListItem
            key={index}
            button
            onClick={() => {
              if (this.props && this.props.onButtonClick) {
                this.props.onButtonClick(item)
              }
            }}
            className={css(Styles.listItem)}
          >
            <p className={css(Styles.label)}>{item.label}</p>
            <span className={css(Styles.icon)}>
              <i className='material-icons-outlined' style={{ fontSize: 16}}>arrow_forward_ios</i>
            </span>
          </ListItem>
        ))}
      </List>
    )
  }
}

const Styles = StyleSheet.create({
  listItem: {
    backgroundColor: '#f9f9f9',
    margin: '2px 0',
    paddingTop: 2,
    paddingBottom: 2,
    borderRadius: 6,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    ':hover': {
      backgroundColor: '#e0e0e0',
    },
  },
  label: {
    color: AppTheme.primaryColor,
    fontSize: 12,
    fontWeight: 500,
    textDecoration: 'none',
    // padding: '12px 16px',
    textAlign: 'left',
    wordBreak: 'break-word',
  },
  icon: {
    color: AppTheme.primaryColor,
  },
})
